export default "__VITE_ASSET__DP8tSp5k__"